export default __webpack_public_path__ + "static/media/Group 3057@2x.5b0a0ec7.png";